import {useStore} from 'vuex'
import {ref, computed, onMounted, watch} from 'vue'

export default {
    name: "ProductDetailTablist",
    setup(){

        const store = useStore()
        const tabListData = computed(() => store.state.productDetails.scraped_tablist_data || [])

        const selectTab = tabIndex => store.commit("productDetails/set_selected_tab", tabIndex)
        
        return {
            tabListData,
            selectTab
        }
    }
}